module.exports = __webpack_public_path__ + "static/media/event-friends-iphonex-categories.5c6615ce.jpg";